"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const operators_1 = require("rxjs/operators");
const _ = __importStar(require("lodash"));
const util_rx_1 = require("./util_rx");
exports.BLANK = "";
// ----------------------------------------------------------------------------
// Debugging
function taplog(label, ...vars) {
    return (s) => s.pipe(operators_1.tap(x => console.log(label, x, ...vars)));
}
exports.taplog = taplog;
function log$(s, ...vars) {
    function S(t) {
        return (typeof s === 'function') ? s(t) : s;
    }
    return (source) => source.pipe(util_rx_1.doOnSubscribe(() => console.log(S(), "subscribe", ...vars)), operators_1.finalize(() => console.log(S(), "finalize", ...vars)), operators_1.tap(t => console.log(S(t), t, ...vars), error => console.error(S(), error, ...vars)));
}
exports.log$ = log$;
function LOG(s, x, ...args) {
    console.log(s, x, ...args);
    return x;
}
exports.LOG = LOG;
function LOGTHRU(...vars) {
    var f = null;
    if (vars.length > 0) {
        f = vars.pop();
    }
    console.log(...vars);
    if (f && typeof f === 'function') {
        return f();
    }
    return f;
}
exports.LOGTHRU = LOGTHRU;
// ----------------------------------------------------------------------------
// Object/Map
function subkeys(target, ...keys) {
    return keys.reduce((out, k) => (Object.assign(Object.assign({}, out), { [k]: target[k] })), {});
}
exports.subkeys = subkeys;
function filterObject(map, f = (b) => !!b) {
    const ret = {};
    for (const k in map) {
        if (f(map[k]))
            ret[k] = map[k];
    }
    return ret;
}
exports.filterObject = filterObject;
// ----------------------------------------------------------------------------
// Enumerable/Array
function compact(source) {
    return _.filter(source, (x) => x !== null && x !== undefined);
}
exports.compact = compact;
function withoutFirst(a, t) {
    const x = _.findIndex(a, i => _.isEqual(i, t));
    if (x < 0)
        return a;
    const r = [...a];
    r.splice(x, 1);
    return r;
}
exports.withoutFirst = withoutFirst;
function filterTruthy(a) {
    return Array.from(a).filter(t => !!t);
}
exports.filterTruthy = filterTruthy;
function arrayRemove(array, f) {
    const index = array.findIndex(f);
    if (index >= 0) {
        array.splice(index, 1);
    }
    return array;
}
exports.arrayRemove = arrayRemove;
function isEmpty(array) {
    return array.length == 0;
}
exports.isEmpty = isEmpty;
function last(a) {
    if (a.length <= 0)
        return null;
    return a[a.length - 1];
}
exports.last = last;
function next(array, target) {
    const i = array.findIndex(t => target === t);
    if (i < 0 || i >= array.length)
        return null;
    return array[i + 1];
}
exports.next = next;
function findInstanceOf(a, type) {
    for (let i of a) {
        if (i instanceof type)
            return i;
    }
    return undefined;
}
exports.findInstanceOf = findInstanceOf;
function includedOrDefault(t, ts, _default) {
    if (ts.find(x => x === t))
        return t;
    return _default;
}
exports.includedOrDefault = includedOrDefault;
function filterInstances(array, klass) {
    return array.filter(x => x instanceof klass);
}
exports.filterInstances = filterInstances;
function filterType(ts, f) {
    return ts.filter(f);
}
exports.filterType = filterType;
function objectToArray(obj) {
    return Object.keys(obj).map(key => [key, obj[key]]);
}
exports.objectToArray = objectToArray;
function objectFromArray(array) {
    return array.reduce((obj, [k, v]) => {
        obj[k] = v;
        return obj;
    }, {});
}
exports.objectFromArray = objectFromArray;
// ----------------------------------------------------------------------------
// Map/Object
function mapmap(map, f) {
    const ret = {};
    for (const k in map) {
        ret[k] = f(map[k]);
    }
    return ret;
}
exports.mapmap = mapmap;
function MAP(object) {
    return new Map(Object.entries(object));
}
exports.MAP = MAP;
// ----------------------------------------------------------------------------
// Functional
function iff(a, f) {
    if (!!a)
        return f(a);
    return null;
}
exports.iff = iff;
function apply(t, f) {
    f(t).bind(t);
    return t;
}
exports.apply = apply;
function wiht(input, f) {
    return f(input);
}
exports.wiht = wiht;
function alos(input, f) {
    f(input);
    return input;
}
exports.alos = alos;
// ----------------------------------------------------------------------------
// String
function trim2(s) {
    return s.replace(/^[\s\0]+/, "")
        .replace(/[\s\0]+$/, "");
}
exports.trim2 = trim2;
function insertAt(s1, index, s2) {
    return s1.substr(0, index) + s2 + s1.substr(index);
}
exports.insertAt = insertAt;
function generateId() {
    return Math.random().toString(36).substring(2) +
        (new Date()).getTime().toString(36);
}
exports.generateId = generateId;
function rand(i) {
    return Math.floor(Math.random() * i);
}
exports.rand = rand;
function ifNumber(x, or) {
    if (_.isNumber(x))
        return x;
    else
        return or;
}
exports.ifNumber = ifNumber;
function now() {
    return (new Date()).getTime();
}
exports.now = now;
// ----------------------------------------------------------------------------
// DOM/React related
function isFocused(dom) {
    if (document.activeElement) {
        return (document.activeElement === dom);
    }
    return false;
}
exports.isFocused = isFocused;
class Queue {
    constructor() {
        this.q = [];
        this.subscribers = [];
    }
    subscribe(subscriber) {
        this.subscribers.push(subscriber);
        this.resolve();
        return () => {
            arrayRemove(this.subscribers, i => i === subscriber);
        };
    }
    push(t) {
        this.q.push(t);
        this.resolve();
    }
    resolve() {
        this.q.forEach(t => this.subscribers.forEach(s => s(t)));
        this.q = [];
    }
}
exports.Queue = Queue;
// =======================================================================
class Range {
    constructor(index, length) {
        this.index = index;
        this.length = length;
    }
}
exports.Range = Range;
// =======================================================================
function typeCheck(value, type, _default) {
    if (typeof value === type)
        return value;
    return _default;
}
exports.typeCheck = typeCheck;
// =======================================================================
function toMap(source, f) {
    const pairs = source.map(a => ([f(a), a]));
    return new Map(pairs);
}
exports.toMap = toMap;
